import React from 'react';

export interface IconAppleProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconApple: React.FC<IconAppleProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M8.25 20.6351C7.875 20.5135 7.5 20.2703 7.25 19.7838C7 19.5405 6.75 19.1757 6.375 18.6892C5.875 17.9595 5.375 16.9865 5 16.0135C4.625 14.9189 4.5 13.8243 4.5 12.7297C4.5 11.5135 4.75 10.5405 5.25 9.68919C5.625 8.95946 6.25 8.47297 6.875 7.98649C7.5 7.62162 8.25 7.37838 9 7.37838C9.25 7.37838 9.5 7.37838 9.875 7.5C10.125 7.5 10.375 7.62162 10.75 7.74324C11.125 7.86486 11.375 7.98649 11.5 7.98649C11.75 8.10811 12 8.10811 12.125 8.10811C12.25 8.10811 12.375 8.10811 12.625 7.98649C12.75 7.98649 13 7.86486 13.25 7.74324C13.5 7.62162 13.75 7.5 14 7.5C14.25 7.5 14.5 7.37838 14.75 7.37838C15 7.37838 15.375 7.25676 15.625 7.37838C16.125 7.37838 16.625 7.5 17.125 7.74324C17.875 7.98649 18.5 8.59459 19 9.2027C18.875 9.2027 18.625 9.32432 18.5 9.56757C18.125 9.93243 17.75 10.2973 17.5 10.6622C17.25 11.2703 17 11.8784 17 12.6081C17 13.4595 17.25 14.1892 17.625 14.7973C17.875 15.2838 18.375 15.6486 18.75 15.8919C19.125 16.0135 19.375 16.1351 19.5 16.2568C19.5 16.5 19.375 16.8649 19.25 16.9865C19 17.7162 18.625 18.2027 18.25 18.8108C17.875 19.2973 17.625 19.6622 17.5 19.7838C17.125 20.1486 16.875 20.5135 16.5 20.6351C16.25 20.8784 15.875 21 15.375 21C15.125 21 14.875 21 14.625 20.8784C14.5 20.8784 14.25 20.7568 14 20.6351C13.625 20.5135 13.5 20.3919 13.25 20.3919C13 20.2703 12.625 20.2703 12.375 20.2703C12.125 20.2703 11.75 20.2703 11.5 20.3919C11.25 20.3919 11 20.5135 10.75 20.6351C10.375 20.7568 10.25 20.8784 10.125 20.8784C9.875 21 9.625 21 9.375 21C9 21 8.625 20.8784 8.25 20.6351ZM13.5 6.77027C13 7.01351 12.5 7.13514 12 7.13514C11.875 6.64865 12 6.16216 12.25 5.55405C12.5 5.06757 12.625 4.7027 13 4.33784C13.375 3.97297 13.75 3.60811 14.25 3.36487C14.75 3.12162 15.25 3 15.75 3C15.75 3.48649 15.625 3.97297 15.5 4.58108C15.375 5.06757 15 5.43243 14.75 5.7973C14.375 6.28378 14 6.52703 13.5 6.77027Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconApple;
